import { Component } from '@angular/core';
import { NmSidebarItem } from './sidebar.interface';
import { config } from '../../config/sidebar.config';

@Component({
	selector: 'nm-sidebar',
	templateUrl: './sidebar.html',
	styleUrls: ['./sidebar.css'],
	host: {
		'class': 'sidebar responsive-min compact',
		'id': 'sidebar',
		'data-sidebar': 'true',
		'data-sidebar-scroll': 'true',
		'data-sidebar-hover': 'true',
	}
})
export class NmSidebar {

	public items: any[];

	public constructor(

	) {
		// TODO: recursive create sidebar, currently only 2 levels
		// TODO: add roles checking
		this.items = config;
	}

}


// WEBPACK FOOTER //
// ./src/widgets/sidebar/sidebar.ts